import { TextareaHTMLAttributes, forwardRef } from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

interface FormTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  icon?: LucideIcon;
  label?: string;
  error?: string;
}

const FormTextarea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  ({ icon: Icon, label, error, id, className, ...props }, ref) => {
    return (
      <div>
        {label && (
          <label htmlFor={id} className="block text-sm font-medium text-muted-foreground mb-1.5">
            {label}
          </label>
        )}
        <div className="relative">
          {Icon && (
            <Icon className="absolute left-3.5 top-3.5 w-[18px] h-[18px] text-muted-foreground/60" />
          )}
          <textarea
            ref={ref}
            id={id}
            className={cn(
              'w-full py-3 bg-background/60 border border-border rounded-xl text-foreground placeholder-muted-foreground/50',
              'focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary/50',
              'transition-colors min-h-[100px] resize-y',
              Icon && 'pl-11',
              !Icon && 'pl-4',
              'pr-4',
              error && 'border-destructive focus:border-destructive focus:ring-destructive/50',
              className,
            )}
            {...props}
          />
        </div>
        {error && (
          <p className="mt-1.5 text-sm text-destructive">{error}</p>
        )}
      </div>
    );
  }
);

FormTextarea.displayName = 'FormTextarea';

export default FormTextarea;
